const WSConsts = {
  roles: {
    contributor: 'contributor',
    director: 'director',
    invitee: 'invitee'
  }
}

class WS {
  constructor (name, logger, agent) {
    this.a = btoa(agent.toString())
    this.fs = null
    this.name = name
    this.l = logger
    this.os = []
    this.rs = {}
  }
  setBaseURL (options) {
    if (options.baseURL) {
      this.baseURL = options.baseURL
    } else {
      this.baseURL = 'wss://' + options.subdomain + '.' + options.domain + '/v1/websocket'
    }
    this.baseURL += '?'
    if (this.a) this.baseURL += 'narative_agent=' + encodeURIComponent(this.a) + '&'
    this.baseURL += 'access_token='
  }
  open (accessToken, filter, onclose) {
    // Websocket is already open
    if (this.s) return

    // Store filter
    if (filter) this.fs = filter

    // Create promise
    // This was added for the catcher so that it catches when the access token has expired
    // Make sure not to override promise closures so that initial promise can still be used
    // in case of retry
    var p = null
    if (!this.reject && !this.resolve) {
      p = new Promise(function (resolve, reject) {
        this.reject = function () {
          reject()
          this.reject = null
          this.resolve = null
        }.bind(this)
        this.resolve = function () {
          resolve()
          this.reject = null
          this.resolve = null
        }.bind(this)
      }.bind(this))
    }

    // Store date
    this.os.push(Date.now())
    if (this.os.length === 4) this.os.shift()

    // Create filter query params
    var fs = ''
    if (this.fs) {
      for (var k in this.fs) {
        fs += '&' + k + '=' + encodeURIComponent(this.fs[k].join(','))
      }
    }

    // Create websocket
    this.debug('opening ')
    this.s = new WebSocket(this.baseURL + accessToken + fs)

    // Handle close
    this.s.onclose = this.onclose(accessToken, onclose).bind(this)

    // Handle open
    this.s.onopen = this.onopen.bind(this)

    // Handle error
    this.s.onerror = function (err) { console.error(err) }

    // Handle message
    this.s.onmessage = this.onmessage.bind(this)
    return p
  }
  debug (msg, remote) {
    this.l.debug('ws.' + this.name, msg, remote)
  }
  close () {
    clearTimeout(this.rt)
    if (!this.s) return
    this.debug('closing')
    this.closing = true
    this.s.close()
  }
  onclose (accessToken, onclose) {
    return function (err) {
      this.debug('closed')
      this.debug('clearing ping timeout')
      clearTimeout(this.p)
      this.s = null
      if (!this.closing) {
        if (onclose) {
          onclose(err)
            .then((accessToken) => {
              // Retry
              this.retry(accessToken, onclose)
            })
            .catch(err => {
              // Log
              console.error(err)

              // Retry
              if (err.retry) {
                this.retry(accessToken, onclose)
                return
              }

              // Reject
              if (this.reject) this.reject(err)
            })
        } else {
          this.retry(accessToken, onclose)
        }
      }
      this.closing = false
    }.bind(this)
  }
  retry (accessToken, onclose) {
    // Do not inject filters in open() here since calling filter() will update them

    // If there are more than 2 tries in less than 2s we timeout before retrying
    // This may be due to a server problem therefore we don't want to DDOS
    if (this.os.length === 3 && (this.os[2] - this.os[0]) < 2000) {
      this.rt = setTimeout(this.open.bind(this), this.retryTimeout(), accessToken, null, onclose)
      return
    }

    // Open
    this.open(accessToken, null, onclose)
  }
  retryTimeout () {
    const t = ((Math.random() * 20 + 1) * 1000).toFixed(0)
    this.debug('retrying in ' + (t / 1000).toFixed(0) + 's')
    return t
  }
  onopen () {
    this.debug('opened')
    this.setPingTimeout()
  }
  ping () {
    this.debug('pinging')
    this.send('ping')
    this.setPingTimeout()
  }
  setPingTimeout () {
    this.p = setTimeout(this.ping.bind(this), 50000)
  }
  registerReceiver (r) {
    this.rs[r._uid] = r
  }
  unregisterReceiver (r) {
    delete this.rs[r._uid]
  }
  onmessage (e) {
    const d = JSON.parse(e.data)
    this.debug('received ' + e.data)
    for (var k in this.rs) {
      this.rs[k].$emit(this.eventName(d.event_name), d.payload)
    }
    if (d.event_name === 'welcome' && this.resolve) this.resolve(d.payload)
  }
  on (receiver, name, handler) {
    receiver.$on(this.eventName(name), handler)
  }
  send (eventName, payload) {
    if (!this.s) return
    const d = JSON.stringify({ event_name: eventName, payload: payload })
    this.debug('sending ' + d)
    try {
      this.s.send(d)
    } catch (err) {
      this.debug('sending failed: ' + err, true)
    }
  }
  eventName (name) {
    return 'ws.' + this.name + '.' + name
  }
  filter (filter) {
    this.fs = filter
    this.send('filter', filter)
  }
}

export {
  WS,
  WSConsts
}
